/**
 * Nested router for the /cash/* section. Wired into App.tsx as a single
 * splat route; all sub-routes live under this tree.
 */
import { Navigate, Route, Routes } from 'react-router-dom';
import { CashHomePage } from './CashHomePage';
import { CashAccountsPage } from './CashAccountsPage';
import { CashAccountLedgerPage } from './CashAccountLedgerPage';

export default function CashRouter() {
  return (
    <Routes>
      <Route index element={<CashHomePage />} />
      <Route path="accounts" element={<CashAccountsPage />} />
      <Route path="accounts/:id" element={<CashAccountLedgerPage />} />
      <Route path="accounts/:id/ledger" element={<CashAccountLedgerPage />} />
      <Route path="*" element={<Navigate to="" replace />} />
    </Routes>
  );
}
